/**
 * Die `NutzerSeite` als nachgeladener Chunk: sie (samt `NutzerFormular.tsx`) gehört nicht ins Eintrittsbündel (Grenze und
 * NEGATIVLISTE, Kategorie N, in `test/reference/bundle.test.ts`), erst das Öffnen der Seite lädt sie. `App.tsx` zeichnet
 * sie nur bei aktiver Seite (`{seite === "users" ? <NutzerSeiteLazy … /> : null}`), der Abruf kostet also erst dann.
 * Muster ist `components/Drawer/TrennenDialogLazy.tsx`.
 *
 * Diese Hülle importiert die Seite nur zur Laufzeit und ihre Props nur als Typ (`import type` wird gelöscht): ein statischer
 * Import von `NutzerSeite.tsx` zöge sie samt `NutzerFormular.tsx` zurück ins Eintrittsbündel. `RollenAuswahl.tsx` und
 * `PasswortDialog.tsx` bleiben dort, weil `App.tsx` und andere Eintrittsmodule sie ebenfalls brauchen.
 *
 * Scheitert der Abruf (alter Tab nach einem Deployment kennt `NutzerSeite-<hash>.js` nicht mehr), wirft `React.lazy` beim
 * Rendern und die Wurzelgrenze (`FehlerGrenze` in `src/App.tsx`) fordert zum Neuladen auf - bei einer ganzen Seite die
 * richtige Antwort, anders als bei den Dialogen (`MassenuploadDialogLazy.tsx`), die den Rest der Anwendung stehen lassen.
 */
import { lazy, Suspense } from "react";
import type { JSX } from "react";
import type { NutzerSeiteProps } from "./NutzerSeite.tsx";

const NutzerSeiteChunk = lazy(() => import("./NutzerSeite.tsx").then((m) => ({ default: m.NutzerSeite })));

/** Platzhalter in der Seitenfläche, bis der Chunk da ist; dieselbe Hülle `.users-shell` wie die Seite selbst. */
function Ladehinweis(): JSX.Element {
  return (
    <div className="users-shell">
      <p role="status">Nutzerverwaltung wird geladen …</p>
    </div>
  );
}

export function NutzerSeiteLazy(props: NutzerSeiteProps): JSX.Element {
  return (
    <Suspense fallback={<Ladehinweis />}>
      <NutzerSeiteChunk {...props} />
    </Suspense>
  );
}
